<section class="block default-padding margin--bottom-l">
  <div class="default-max-width centered">
    <div class="layout-hero-tiles">
      <div class="layout-hero-tiles-item">
        <div class="relative js-slider no-overflow">
          <div class="swiper-button-prev swiper-button-prev-{{ data.id }} mobile-hidden">
            <i class="icon-arrow-5"></i>
          </div>
          <swiper *ngIf="heroSwiperConfig" [config]="heroSwiperConfig">
            <ng-template swiperSlide *ngFor="let slide of data.slides">
              <div
                *ngIf="slide.teaser.image.formats?.large?.url || slide.teaser.image?.url"
                class="bg-image-tile"
                [ngStyle]="{
                  'background-image': 'url(' + (slide.teaser.image.formats?.large?.url || slide.teaser.image?.url) + ')'
                }"
              >
                <div class="bg-image-tile-main bg-image-tile-push">
                  <p class="headline-third"></p>
                  <p class="bg-image-tile-title headline-first">
                    {{ slide.teaser.title }}
                  </p>

                  <div class="default-font-sizes">
                    <p>
                      {{ slide.teaser.teaserText }}
                    </p>
                  </div>

                  <a href="{{ slide.teaser.link }}" class="bg-image-tile-button btn btn--small btn--bright" *ngIf="slide.teaser.button">{{
                    slide.teaser.button
                  }}</a>
                </div>
              </div>
            </ng-template>
          </swiper>
          <div class="swiper-button-next mobile-hidden swiper-button-next-{{ data.id }}">
            <i class="icon-arrow-5"></i>
          </div>
        </div>
        <div class="bg-image-tile-slider-pagination swiper-pagination swiper-pagination--bright swiper-pagination-{{ data.id }}">
          <div id="swiper-pagination-bg-image-tile"></div>
        </div>
      </div>
    </div>
  </div>
</section>
